// Notifications push de l'espace chauffeur (service worker /driver-sw.js).
// iOS ≥ 16.4 n'autorise le push que pour une PWA ajoutée à l'écran d'accueil.

const SW_URL = "/driver-sw.js";

export function isPushSupported() {
  return typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export function isStandalone() {
  if (typeof window === "undefined") return false;
  return (
    (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) ||
    window.navigator.standalone === true
  );
}

export function isIOS() {
  if (typeof navigator === "undefined") return false;
  return /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
}

export function permissionState() {
  if (typeof Notification === "undefined") return "unsupported";
  return Notification.permission; // default | granted | denied
}

export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    const reg = await navigator.serviceWorker.register(SW_URL, { scope: "/" });
    return reg;
  } catch (e) {
    return null;
  }
}

export async function getExistingSubscription() {
  if (!isPushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration("/");
  if (!reg) return null;
  return reg.pushManager.getSubscription();
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) out[i] = raw.charCodeAt(i);
  return out;
}

// Demande la permission puis crée l'abonnement. Renvoie le PushSubscription
// (toJSON() pour l'envoyer au serveur) ou lève une Error avec un message lisible.
export async function subscribeToPush(publicKey) {
  if (!isPushSupported()) throw new Error("Notifications non prises en charge sur cet appareil");
  if (!publicKey) throw new Error("Notifications non configurées");
  const reg = (await registerServiceWorker()) || (await navigator.serviceWorker.ready);
  if (!reg) throw new Error("Service worker indisponible");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Permission refusée");
  const existing = await reg.pushManager.getSubscription();
  if (existing) return existing;
  return reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: urlBase64ToUint8Array(publicKey) });
}

export async function unsubscribeFromPush() {
  const sub = await getExistingSubscription();
  if (!sub) return null;
  const endpoint = sub.endpoint;
  await sub.unsubscribe();
  return endpoint;
}
